<div class="d-flex">
  <a
    [attr.aria-label]="appStoreButtonLink().value?.text"
    [href]="appStoreButtonLink().href"
    class="me-2"
    id="app-store-button"
  >
    <wl-app-store-logo />
    <crnt-visually-hidden>{{
      appStoreButtonLink().value?.text
    }}</crnt-visually-hidden>
  </a>
  <a
    [attr.aria-label]="googlePlayButtonLink().value?.text"
    [href]="googlePlayButtonLink().href"
    id="google-play-button"
  >
    <wl-google-play-logo />
    <crnt-visually-hidden>{{
      googlePlayButtonLink().value?.text
    }}</crnt-visually-hidden>
  </a>
</div>
